import React from 'react'
import InputRange from 'react-input-range'
import 'react-input-range/lib/css/index.css'
import styles from './RangeSlider.module.scss'

interface Values {
  min: number
  max: number
}

interface RangeSliderProps {
  value: Values
  onChange: (values: Values) => void
  minValue?: number
  maxValue?: number
}

const RangeSlider: React.FC<RangeSliderProps> = ({ ...props }) => {
  return (
    <div className={styles.sliderWrapper}>
      <InputRange {...props} />
    </div>
  )
}

export default RangeSlider
